import Vue from "vue"
import VueRouter from "vue-router"
import Home from "../views/Home.vue"
import Host from "../views/Host.vue"
import Mod from "../views/Mod.vue"

Vue.use(VueRouter)

const routes = [
  {
    path: "/",
    name: "Bleach London Hair Party",
    component: Home
  },
  {
    path: "/host",
    name: "Host",
    component: Host
  },
  {
    path: "/sofabythewindow",
    name: "Moderator",
    component: Mod
    // meta: { requiresAuth: "Basic" }
  }
]

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
})

// router.beforeEach((to, from, next) => {
//   if (to.matched.some(record => record.meta.requiresAuth == "Basic")) {
//     if (store.state.isLoggedIn) {
//       next()
//       return
//     }
//     next("/login")
//   } else {
//     next()
//   }
// })

export default router
